// extracted by mini-css-extract-plugin
module.exports = {"info":"_d6616f6","typeInfo":"_065e7fe","typeConfirmation":"_c960029","typeError":"_3473a43","typeWarning":"_0a9f338"};